<script setup lang="ts">
import { computed } from 'vue'
import type { ChartProgress } from '../types'
import { spacingClasses } from '../utils/classes'

const props = defineProps<{ element: ChartProgress }>()

const pct = computed(() => Math.min(100, props.element.max > 0 ? (props.element.value / props.element.max) * 100 : 0))
const color = computed(() => props.element.color ?? '#60a5fa')
</script>

<template>
  <div :class="element.spacing ? spacingClasses[element.spacing] : 'mt-2'">
    <div class="mb-1.5 flex items-baseline justify-between text-sm">
      <span v-if="element.label" class="font-medium">{{ element.label }}</span>
      <span class="ml-auto text-muted-foreground">
        {{ element.value }}{{ element.unit }} / {{ element.max }}{{ element.unit }}
      </span>
    </div>
    <div class="h-2 w-full overflow-hidden rounded-full bg-muted">
      <div
        class="h-full rounded-full transition-all duration-500"
        :style="{ width: `${pct}%`, backgroundColor: color }"
      />
    </div>
  </div>
</template>
